function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module clipboard/datatransfer
 */

/**
 * A facade over the native [`DataTransfer`](https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer) object.
 */
var DataTransfer = /*#__PURE__*/function () {
  function DataTransfer(nativeDataTransfer) {
    _classCallCheck(this, DataTransfer);

    /**
     * The array of files created from the native `DataTransfer#files` or `DataTransfer#items`.
     *
     * @readonly
     * @member {Array.<File>} #files
     */
    this.files = getFiles(nativeDataTransfer);
    /**
     * The native DataTransfer object.
     *
     * @private
     * @member {DataTransfer} #_native
     */

    this._native = nativeDataTransfer;
  }
  /**
   * Returns an array of available native content types.
   *
   * @returns {Array.<String>}
   */


  _createClass(DataTransfer, [{
    key: "types",
    get: function get() {
      return this._native.types;
    }
    /**
     * Gets the data from the data transfer by its MIME type.
     *
     *		dataTransfer.getData( 'text/plain' );
     *
     * @param {String} type The MIME type. E.g. `text/html` or `text/plain`.
     * @returns {String}
     */

  }, {
    key: "getData",
    value: function getData(type) {
      return this._native.getData(type);
    }
    /**
     * Sets the data in the data transfer.
     *
     * @param {String} type The MIME type. E.g. `text/html` or `text/plain`.
     * @param {String} data
     */

  }, {
    key: "setData",
    value: function setData(type, data) {
      this._native.setData(type, data);
    }
    /**
     * The effect that is allowed for a drag operation.
     *
     * @param {String} value
     */

  }, {
    key: "effectAllowed",
    get: function get() {
      return this._native.effectAllowed;
    }
    /**
     * The actual drop effect.
     *
     * @param {String} value
     */
    ,
    set: function set(value) {
      this._native.effectAllowed = value;
    }
  }, {
    key: "dropEffect",
    get: function get() {
      return this._native.dropEffect;
    }
    /**
     * Whether the dragging operation was canceled.
     *
     * @returns {Boolean}
     */
    ,
    set: function set(value) {
      this._native.dropEffect = value;
    }
  }, {
    key: "isCanceled",
    get: function get() {
      return this._native.dropEffect == 'none' || !!this._native.mozUserCancelled;
    }
  }]);

  return DataTransfer;
}();

export { DataTransfer as default };

function getFiles(nativeDataTransfer) {
  // DataTransfer.files and items are array-like and might not have an iterable interface.
  var files = nativeDataTransfer.files ? Array.from(nativeDataTransfer.files) : [];
  var items = nativeDataTransfer.items ? Array.from(nativeDataTransfer.items) : [];

  if (files.length) {
    return files;
  } // Chrome has empty DataTransfer.files, but allows getting files through the items interface.


  return items.filter(function (item) {
    return item.kind === 'file';
  }).map(function (item) {
    return item.getAsFile();
  });
}